export default {
	name: "add-or-update-exTank-order-modal",
	props: ["heading", "modalId", "showModal", "company"],
	emits: ["placeOrderOkClicked"],
	data() {
		return {
			selectedCompany: {},
			billingAddressValidation:{
				hasError: false,
				errorMessage: null
			},
			terminals: [],
			allTerminals: [],
			orderValidationRulesResults: [],
			expectedDateOfUpliftmentStartDate: new Date().setDate(new Date().getDate() - 1),
			initialiseExpectedDate: true,
			order:{
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				totalAmount: 0,
				discountedAmount: 0,
				expectedUpliftmentDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				transporter:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleMake: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleModel: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				terminalId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				selectedTerminal: {}
			},
			orderTypeId: null,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			productFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			hasError: false
		};
	},
	methods: {
		getTerminals(){
			this.loading = true;
			systemService.getTerminals(orderHelper.orderType.exTank, 0).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.terminals = successResponse.data.result;
						this.allTerminals = JSON.parse(JSON.stringify(this.terminals));
						this.terminals = $.map(this.terminals,
							function (obj) {
								obj.id = obj.id || obj.terminalId;
								obj.text = obj.text || obj.name + " (" + obj.zone + ")";
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onExpectedDateOfUpliftmentSelect(date){
			this.order.expectedUpliftmentDate.value = date;
			this.initialiseExpectedDate = false;
			console.log("expectedUpliftmentDate", this.order.expectedUpliftmentDate.value);
		},
		onTerminalSelect(terminal){
			console.log("terminal", terminal);
			this.order.terminalId.value = terminal.id;
			this.order.selectedTerminal = this.allTerminals.find(x => x.terminalId === terminal.id);
		},
		onProductSelected(products){
			this.order.products = [];
			this.order.totalAmount = 0;
			this.order.discountedAmount = 0;
			console.log("products", products);
			this.hasError = products.hasError;
			if(!products.hasError){
				for(let i = 0; i < products.selectedProducts.length; i++){
					let obj = JSON.parse( JSON.stringify( products.selectedProducts[i]));
					let itemToOrder = {
						productId: obj.productId,
						quantity: obj.quantity,
						totalPrice: obj.total,
						unitPrice: obj.basePrice,
						// discountedAmount: obj.discountedAmountTotal
						discountedAmount: obj.discountAmount === null ? 0 : obj.discountAmount
					};
					this.order.products.push(itemToOrder);
					this.order.totalAmount += obj.total;
					this.order.discountedAmount += obj.discountedAmountTotal;
				}
			}
		},
		clearMessageAlerts(){
			this.clearModel();
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			this.orderValidationRulesResults = [];
			this.$emit("placeOrderOkClicked", true);
		},
		onModalCloseClick(){
			this.clearModel();
			this.$emit("placeOrderOkClicked", true);
		},
		onModalSaveClick(){
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			if(this.hasError){
				this.loading = false;
				return;
			}
			let request = {
				customerPurchaseOrder: this.order.customerPurchaseOrderNumber.value,
				orderItems: this.order.products,
				totalAmount: this.order.totalAmount,
				discountedAmount: this.order.discountedAmount,
				expectedUpliftmentDate: this.order.expectedUpliftmentDate.value,
				orderStatusId: 0,
				transporter: this.order.transporter.value,
				vehicleMake: this.order.vehicleMake.value,
				vehicleModel: this.order.vehicleModel.value,
				vehicleRegistration: this.order.vehicleRegistration.value,
				terminalId: this.order.terminalId.value === null ? 0 : this.order.terminalId.value,
			};
			exTankService.addOrUpdateExTankOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.exTankOrderValidationResponse.valuesAreValid){
							this.loading = false;
							this.showSuccessMessage = true;
							this.successMessage = "Order saved successfully";
							this.clearModel();
						}
						else{
							this.order.productsHasError = successResponse.data.exTankOrderValidationResponse.itemsToOrderValidationResponse.hasError;
							this.order.productsErrorMessage = successResponse.data.exTankOrderValidationResponse.itemsToOrderValidationResponse.message;

							this.order.expectedUpliftmentDate.hasError = successResponse.data.exTankOrderValidationResponse.expectedUpliftmentDateValidationResponse.hasError;
							this.order.expectedUpliftmentDate.errorMessage = successResponse.data.exTankOrderValidationResponse.expectedUpliftmentDateValidationResponse.message;
							
							this.order.transporter.hasError = successResponse.data.exTankOrderValidationResponse.transporterValidationResponse.hasError;
							this.order.transporter.errorMessage = successResponse.data.exTankOrderValidationResponse.transporterValidationResponse.message;
							
							this.order.vehicleModel.hasError = successResponse.data.exTankOrderValidationResponse.vehicleModelValidationResponse.hasError;
							this.order.vehicleModel.errorMessage = successResponse.data.exTankOrderValidationResponse.vehicleModelValidationResponse.message;
							
							this.order.vehicleRegistration.hasError = successResponse.data.exTankOrderValidationResponse.vehicleRegistrationValidationResponse.hasError;
							this.order.vehicleRegistration.errorMessage = successResponse.data.exTankOrderValidationResponse.vehicleRegistrationValidationResponse.message;
							
							this.order.terminalId.hasError = successResponse.data.exTankOrderValidationResponse.terminalValidationResponse.hasError;
							this.order.terminalId.errorMessage = successResponse.data.exTankOrderValidationResponse.terminalValidationResponse.message;

							if(successResponse.data.exTankOrderValidationResponse.billingAddressValidationResponse !== null){
								this.billingAddressValidation.hasError = successResponse.data.exTankOrderValidationResponse.billingAddressValidationResponse.hasError;
								this.billingAddressValidation.errorMessage = successResponse.data.exTankOrderValidationResponse.billingAddressValidationResponse.message;

								this.showErrorMessage = this.billingAddressValidation.hasError;
								this.errorMessage = this.billingAddressValidation.errorMessage;
							}

							this.orderValidationRulesResults = successResponse.data.orderValidationResults;

							var modalContent = document.getElementById(this.modalId)
							if (modalContent) {
								modalContent.scrollTop = 0;
							}
						}
					}
					else{
						// failed clear and close modal
						this.clearMessageAlerts();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.orderValidationRulesResults = [];
			this.order = {
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				totalAmount: 0,
				discountedAmount: 0,
				expectedUpliftmentDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				transporter:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleMake: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleModel: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				terminalId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				selectedTerminal: {}
			};
		}
	},
	mounted: function () {
		this.orderTypeId = orderHelper.orderType.exTank;
		this.getTerminals();
	},
	watch:{
		// company:{
		// 	handler: function(){
		// 		this.selectedCompany = this.company;
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		heading: {
			handler: function () {
				if (this.heading) {
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId: {
			handler: function () {
				if (this.modalId) {
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal: {
			handler: function () {
				if (this.showModal) {
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				} else {
					$("#" + this.modalId).modal("hide");
					this.clearModel();
				}
			},
			immediate: true,
			deep: true
		}
	}
};